import { Flow } from 'signup-constants/Flow';
import { SignupEmbedder } from 'signup-embedder';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { ExperimentParameterGroup } from '../experiments/ExperimentParameterGroup';
import { getIsGoogleCredentialAuthentication } from '../google-authentication/google-prompt/getIsGoogleCredentialAuthentication';
import { getFlowKey } from '../routing/getFlowKey';
import { getIntentKey } from '../routing/getIntentKey';
import { getIsActiveAndAssignedToVariant } from '../store/experiments/selectors';
import { getIsMobile } from './deviceUtils';
import { getIsJapan } from './getIsJapan';
import enviro from 'enviro';
import { getQueryParam } from '../routing/getQueryParam';
const ACTIVE_PROD_FLOWS = [Flow.Crm, Flow.Sales, Flow.Marketing, Flow.Service, Flow.CmsFree, Flow.Purchase, Flow.Commerce];
const ACTIVE_QA_FLOWS_BEHIND_QUERY_PARAM = [Flow.Academy, Flow.Developers, Flow.CmsDevelopers];
export const getShouldShowSidePanel = state => {
  const flowKey = getFlowKey();
  const isQA = enviro.isQa();
  const isEnabledByFlow = ACTIVE_PROD_FLOWS.includes(flowKey) || isQA && getQueryParam('sidepanel_enabled') === 'true' && ACTIVE_QA_FLOWS_BEHIND_QUERY_PARAM.includes(flowKey);
  const isJapan = getIsJapan(state);
  const isMobile = getIsMobile();
  const isEmbedded = SignupEmbedder.isActive();
  const intentKey = getIntentKey();
  const isComingFromGooglePrompt = getIsGoogleCredentialAuthentication(state);
  const isAssignedToACQ173Variants = getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ0173, [ExperimentParameterGroup.Variant_A, ExperimentParameterGroup.Variant_B, ExperimentParameterGroup.Variant_C]);
  if (isJapan || isMobile || isEmbedded || intentKey && flowKey !== Flow.Purchase || isComingFromGooglePrompt || isAssignedToACQ173Variants) {
    return false;
  }
  return isEnabledByFlow;
};